module.exports = __webpack_public_path__ + "img/part-4-title.62779288.png";